<template>
	<div>
		<div v-if="formCreateInject">
			<custom-upload :disabled="disabled" :canupload="canupload" :multiple="multiple" :limit="limit" v-model="value" :readonly="readonly"
				:uploadloading="uploadloading" @handlePreview="handlePreview" @onRemove="onRemove"
				@beforeRemove="beforeRemove" @handleExceed="handleExceed" @onSuccess="onSuccess" @onChange="onChange"
				@onError="onError" @httpRequest="httpRequest" @beforeUpload="beforeUpload" @preview="preview"
				@download="download" @print="print" @rename="rename" @handleRemove="handleRemove" />
		</div>
		<div v-else>
			<el-link type="primary" style="font-size: 12px;" @click="showUploadModal" v-if="value">
				<span v-if="!disabled && !readonly">{{ value.length!=0?'文件已上传【'+value.length+'】':'上传文件'}}</span>
				<span v-else>{{value.length!=0?'文件已上传【'+value.length+'】':''}}</span>
			</el-link>
			
			<!-- 			<el-tag size="mini" type="success" style="font-size: 12px;margin-left: 10px;" @click="tableuploadpreview"
				v-if="value.length!=0">{{value[0].name}}</el-tag> -->
		</div>


		<vxe-modal v-model="tableUploadShow" width="500" height="500" title="上传文件" show-footer transfer destroy-on-close
			esc-closable>
			<template #default>
				<custom-upload :disabled="disabled" :multiple="multiple" :limit="limit" v-model="value"
					:readonly="readonly" @handlePreview="handlePreview" @onRemove="onRemove"
					@beforeRemove="beforeRemove" @handleExceed="handleExceed" @onSuccess="onSuccess"
					@onChange="onChange" @onError="onError" @httpRequest="httpRequest" @beforeUpload="beforeUpload"
					@preview="preview" @download="download" @print="print" @rename="rename"
					@handleRemove="handleRemove" />
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="tableUploadShow=false"></vxe-button>
			</template>
		</vxe-modal>


		<vxe-modal v-model="previewShow" width="800" height="800" title="预览" show-footer transfer destroy-on-close
			show-zoom esc-closable @hide="previewHide" :zIndex="99999">
			<template #default>
				<div class="full preload_container">
					<div class="full" style="overflow: auto;box-sizing: border-box;position: relative;">
						<div class="preload_box" id="preload_box">
							<vxe-grid v-if="gridOption" v-bind="gridOption"></vxe-grid>
							<pdf v-if="pdfurl" :src="pdfurl"></pdf>
						</div>
					</div>
				</div>
			</template>
			<template #footer>
				<vxe-button status="success" content="下载" @click="previewdownload"></vxe-button>
				<vxe-button disabled status="" content="返回" @click="previewShow=false"></vxe-button>
			</template>
		</vxe-modal>


		<vxe-modal v-model="previewImgShow" width="48%" height="90%" title="预览" :show-footer="false" transfer
			destroy-on-close show-zoom esc-closable @hide="previewHide" :zIndex="99999" :mask="false" :lock-view="false"
			:position="{top: previewImgIndex * 100 + 1, left: previewImgIndex * 100 + 1}">
			<template #default>
				<div class="full" style="overflow: hidden;">
					<viewer ref="viewer" :options="previewoptions" :images="images" class="viewer">
						<template #default="scope">
							<div v-for="(item) in scope.images" :key="item" class="image-wrapper">
								<img class="full" style="opacity: 0;transform: rotate(-90deg)" :src="item">
							</div>
						</template>
					</viewer>
				</div>
			</template>
		</vxe-modal>




	</div>
</template>
<style scope>
	.upload {
		flex-direction: row;
	}

	.filename {
		flex: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.preload_container {
		background-color: gray;
		box-sizing: border-box;
		padding: 20px;
	}

	.preload_box {
		background-color: white;
		width: 100%;
		min-height: 100%;
		box-sizing: border-box;
	}
</style>
<style>

</style>
<script>
	// import router from '@_system/router/index.js'
	// import Store from '@/store/store.js'
	import JSZip from 'jszip'
	import OSS from 'ali-oss'
	// import * as XLSX from 'xlsx/xlsx.js'
	// import {
	// 	renderAsync
	// } from 'docx-preview'
	import pdf from 'vue-pdf'
	import selectBase from '@_system/components/base/select.js'

	import 'viewerjs/dist/viewer.css'
	import {
		component as Viewer
	} from "v-viewer"
	import {
		api as viewerApi
	} from "v-viewer"
	import customUpload from './lib/index.vue'


	export default {
		mixins: [selectBase],
		props: {
			formCreateInject: {
				default: () => {
					return null
				}
			},
			downloadConfig: {
				default: () => {
					return {
						name: {
							'prefix': '',
							'suffix': '',
						}
					}
				}
			},
			multiple: {
				type: Boolean,
				default: () => {
					return true
				}
			},
			limit: {
				type: Number,
				default: () => {
					return 100
				}
			},
			fileList: {
				default: (e) => {
					return e ? e : []
				}
			},
			value: {
				default: (e) => {
					return e ? e : []
				}
			},
			moduleName: {
				type: String,
				default: () => {
					return null
				}
			},

			disabled: {
				type: Boolean,
				default: () => {
					return false
				}
			},
			readonly: {
				default: () => {
					return false
				}
			},
			canupload: {
				default: () => {
					return true
				}
			},
			type: {
				type: Array,
				default: () => {
					return ['DOCX', 'TXT', 'XLSX','XLS','PNG', 'JPG', 'JPEG', 'PDF', 'OFD', 'ZIP','RAR', 'CSV']
				}
			},
			previewImgModal: {
				default: () => {
					return false
				}
			},
			previewImgIndex: {
				default: () => {
					return 0
				}
			},
			autopreviewImg: {
				default: () => {
					return false
				}
			}
		},
		data() {
			return {
				images: [],
				//value:[],
				previewoptions: {
					inline: true,
					button: true,
					navbar: true,
					title: true,
					toolbar: true,
					tooltip: true,
					movable: true,
					zoomable: true,
					rotatable: true,
					scalable: true,
					transition: true,
					fullscreen: false,
					keyboard: true,
					zIndex: 999999,
					rotated: this.rotated,
					viewed: this.viewed

				},
				uploadloading: false,
				store: {},
				tableUploadShow: false,
				previewShow: false,
				previewImgShow: false,
				previewtitle: '预览',
				blob: null,
				file: null,
				gridOption: null,
				pdfurl: null,
				printimg: null,
				componentId: Math.random(),
				printObj: {
					id: 'upload_print_content',
					closeCallback: () => {
						this.printimg = null
					}
				},
				viewer: null,
				currentViewIndex: 0,

			}
		},
		created() {

		},
		mounted() {
			// this.initvalue()
			let file = this.initvalue()
			if(Array.isArray(this.value)){
				this.value.forEach((item) => {
					this.createIcon(item)
				})
				file = this.initvalue()
			}else{
				file.forEach((item) => {
					this.createIcon(item)
				})
			}

			
			this.$nextTick(() => {
				if (this.autopreviewImg) {
					this.previewIMG(null, file)
				}
				this.isReady = true
			})

		},
		watch: {
			value() {
				//this.initvalue()
				// console.log(val,11111)
				if(Array.isArray(this.value)){
					this.value.forEach((item) => {
						this.createIcon(item)
					})
				}
			}
		},
		computed: {

		},
		destroyed() {


		},
		methods: {
			initvalue(){
				return this.value && Array.isArray(this.value) ? JSON.parse(JSON.stringify(this.value)) : []
			},
			rotated(e) {
				//console.log(e)
				this.$emit('imgrotated', {
					index: this.currentViewIndex,
					previewImgIndex: this.previewImgIndex,
					degree: e.detail.degree - e.detail.oldDegree,
				})
				//console.log(e.detail.degree, this.currentViewIndex)
			},
			viewed(e) {
				//console.log(e)
				this.currentViewIndex = e.detail.index
			},
			clear() {
				if (this.viewer) {
					this.viewer.destroy()
				}
				this.images = []
				this.previewImgShow = false
			},
			inited(viewer) {
				this.viewer = viewer
			},
			print(file) {
				//console.log(file)
				let type = file.path.split('.')
				type = type[type.length - 1].toUpperCase()
				if (type == 'PDF') {
					window.open(file.path, '_blank');
				} else if (type == 'JPG' || type == 'JPEG' || type == 'PNG') {
					// if (file.path.startsWith('http://')) {
					// 	file.path = file.path.replace('http://', 'https://');
					// }
					//console.log(file.path)
					this.printimg = file.path
					this.$nextTick(() => {
						this.$refs.printButton.click()
					})
				} else {
					this.$message.error('仅支持PDF和图片')
				}

			},
			rename(file) {
				let type = this.getFileType(file)
				let title = file.name.split('.')[0]
				this.$prompt('请输入新名称', title).then((e) => {

					file.name = e.value + '.' + type.toLowerCase()
				})
			},
			handleRemove(file) {
				// this.value.forEach((item, index) => {
				// 	if (item.uid == file.uid) {
				// 		this.value.splice(index, 1)
				// 	}
				// })
				//console.log(this.value)
				this.changefile(file, this.value)
			},
			onRemove() {
				//this.changefile(file, fileList)

			},
			handlePreview(file) {
				this.$emit('handlePreview', {
					file: file
				})

			},
			handleExceed(file, fileList) {
				this.$message.error('超出上传限制')
				this.$emit('handleExceed', {
					file: file,
					fileList: fileList
				})
			},
			beforeRemove(file, fileList) {
				this.$emit('beforeRemove', {
					file: file,
					fileList: fileList
				})
			},
			onSuccess() {

			},
			beforeUpload() {

			},
			onChange() {

				//this.changefile(file, fileList)
			},
			// change() {

			// },
			tableuploadpreview() {
				this.preview(this.value[0])
			},
			showUploadModal() {
				this.value.forEach((item) => {
					this.createIcon(item)
				})
				this.tableUploadShow = true
			},
			tableuploadfile() {
				const fileInput = document.createElement('input');
				fileInput.type = 'file';
				fileInput.accept = '.docx,.pdf';
				fileInput.addEventListener('change', (event) => {
					const file = event.target.files[0];
					if (file) {
						this.httpRequest({
							file: file
						})
					}
				});
				fileInput.click();
			},
			uploadfile(obj, filetype) {
				if (this.type.indexOf(filetype) !== -1) {
					this.uploadloading = true
					this.uploadOss(obj.file, this.moduleName).then((res) => {
						let ossres = {
							name: obj.file.name,
							path: res.url,
							uid: obj.file.uid,
							url: res.url
						}
						this.createIcon(ossres)
						ossres.type = this.getFileType(ossres)
						this.$emit('afterUploadOss', ossres)
						this.value.push(ossres)
						this.uploadloading = false
						//console.log(JSON.parse(JSON.stringify(this.value)))
						this.change(JSON.parse(JSON.stringify(this.value)))
						//alert(123)

					}, () => {
						this.uploadloading = false
						this.$message.error('上传失败')
					})
				} else {
					this.$message.error('文件格式不支持')
				}
			},
			createIcon(file) {
				//console.log(file,123123)
				let filetype = this.getFileType(file)
				let url = ''
				if (filetype == 'XLSX' || filetype == 'XLS' || filetype == 'CSV') {
					url = require('@_system/icon/xls.png')
				} else if (filetype == 'DOCX') {
					url = require('@_system/icon/doc.png')
				} else if (filetype == 'TXT') {
					url = require('@_system/icon/txt.png')
				} else if (filetype == 'PNG' || filetype == 'JPG' || filetype == 'JPEG') {
					url = file.path
				} else if (filetype == 'PDF') {
					url = require('@_system/icon/pdf.png')
				} else if (filetype == 'ZIP' || filetype == 'RAR') {
					url = require('@_system/icon/zip.png')
				} else if (!this.formCreateInject) {
					this.value.length = 0
				} else {
					url = require('@_system/icon/txt.png')
				}
				file.url = url
			},
			httpRequest(e) {
				if (!Array.isArray(e)) {
					this.uploadfile(e, this.getFileType(e.file))
				} else {
					e.forEach((item) => {
						this.uploadfile(item, this.getFileType(item.file))
					})
				}
			},
			uploadOss(file, moduleName) {
				let dir = moduleName?moduleName:'common'
				return new Promise((reslove, reject) => {
					this.$api.upload.config().then((res) => {
						let config = {...window.config.oss,...res.data}
						let client = new OSS(config)
						let name = dir + '/' + Date.now() + '_' + (Math.random() * 100000).toFixed(0) + file
							.name
						client.put(name, file).then((res) => {
							reslove(res)
						}).catch((e) => {
							reject(e)
						})
					})			
				})
			},
			onError(e = null) {
				if (!e) {
					this.$message.error('文件上传失败,请重试')
				} else {
					this.$message.error(e)
				}
			},
			changefile(file, fileList) {
				for (let i = this.value.length - 1; i >= 0; i--) {
					let ele = fileList.find((item) => {
						return item.uid == this.value[i].uid
					})
					if (!ele) {
						this.value.splice(i, 1)
					}
				}
				if (this.el) {
					this.formCreateInject.api.validateField(this.formCreateInject.field)
				}
				this.$emit('input', this.value)
			},

			download(file, blob = null) {
				let fileList = JSON.parse(JSON.stringify(this.value))
				// this.$emit('beforeDownload',{file:file,fileList:fileList})
				//console.log(this.value, blob)
				if (blob) {
					let url = blob
					let link = document.createElement('a')
					link.style.display = 'none'
					link.href = URL.createObjectURL(url)
					link.setAttribute('download', this.getFileName(file.name))
					document.body.appendChild(link)
					link.click();
					link.remove();
				} else {
					let obj = {}
					if (fileList.length > 1) {
						let handle = this.$loading()
						let blobs = []
						fileList.forEach((file) => {
							let filetype = this.getFileType(file)
							obj = {
								path: file.path,
								name: this.getFileName(file.name),
								filetype: filetype
							}
							this.$api.upload.download(obj).then((res) => {
								let url = new Blob([res.data])
								blobs.push({
									blob: url,
									filename: this.getFileName(file.name)
								})
								if (blobs.length == fileList.length) {
									this.downloadFilesAsZip(blobs)
									this.$loadingclose(handle)
								}
							})
						})

					} else {
						let filetype = this.getFileType(file)
						obj = {
							path: file.path,
							name: this.getFileName(file.name),
							filetype: filetype
						}

						this.$api.upload.download(obj).then((res) => {
							let url = new Blob([res.data])
							this.blob = url
							let link = document.createElement('a')
							link.style.display = 'none'
							link.href = URL.createObjectURL(url)
							link.setAttribute('download', this.getFileName(file.name))
							document.body.appendChild(link)
							link.click();
							link.remove();
						})
					}
				}
			},
			getFileName(name) {
				let prename = name.split('.')
				let filetype = prename.pop()
				//console.log(prename)
				let namearr = []
				if (this.downloadConfig.name.prefix) {
					namearr.push(this.downloadConfig.name.prefix)
				}
				namearr.push(prename.join('.'))
				if (this.downloadConfig.name.suffix) {
					namearr.push(this.downloadConfig.name.suffix)
				}

				return namearr.join('_') + '.' + filetype
			},
			preview(file) {
				this.file = file
				//this.previewtitle = '预览' + '（' + file.name + '）'
				let filetype = this.getFileType(file)
				if (filetype != 'XLSX') {
					this.gridOption = null
				}
				this.$api.upload.download({
					path: file.path,
					name: file.name,
					filetype: filetype
				}).then((res) => {
					this.pdfurl = null
					this.blob = new Blob([res.data])
					if (filetype == 'XLSX' || filetype == 'XLS' || filetype == 'CSV') {
						//this.previewShow = true
						this.previewXLSX(res, file,filetype)
					} else if (filetype == 'DOCX') {
						//this.previewShow = true
						this.previewDOCX(res, file)
					} else if (filetype == 'TXT') {
						this.previewShow = true
						this.previewTXT(res, file)
					} else if (filetype == 'PNG' || filetype == 'JPG' || filetype == 'JPEG') {
						this.previewShow = false
						this.previewIMG(res, file)
					} else if (filetype == 'PDF') {
						//this.previewShow = true
						this.previewPDF(res, file)
					} else {
						this.$message.error('不支持预览')
					}
				})
			},

			previewXLSX(res, file,filetype) {
				
				window.open('https://view.officeapps.live.com/op/view.aspx?src='+file.path, '_blank');
				
				
				console.log(res,file,filetype)
				// if(filetype!='XLSX'){
				// 	this.$message.error('仅支持预览XLSX')
				// 	return
				// }
				// if (window.lucksheet && !window.lucksheet.closed) {
				// 	window.lucksheet.postMessage({
				// 		type:'create',
				// 		file: new window.File([this.blob], file.name),
				// 	}, '*');
				// } else {
				// 	let page = router.resolve({
				// 		name: 'custompage',
				// 		query: {
				// 			name: 'lucksheet',
				// 		}
				// 	})
				// 	let lucksheet = window.open(page.href, "lucksheet",
				// 		Store.store.state.system.windowConfig)
				// 		lucksheet.onload = () => {
				// 			window.addEventListener('message', (event) => {
				// 				if (event.data.type === 'lucksheetload') {
				// 					window.lucksheet.postMessage({
				// 						type:'create',
				// 						file: new window.File([this.blob], file.name),
				// 					}, '*');
				// 				}
				// 			}, {renderAsync
				// 				once: true
				// 			})
				// 		}
				// 		window.lucksheet = lucksheet
					
				// }
			},
			previewDOCX(res, file) {
				window.open('https://view.officeapps.live.com/op/view.aspx?src='+file.path, '_blank');
				// let blob = this.blob
				// let reader = new FileReader()
				// reader.readAsArrayBuffer(new window.File([blob], file.name, {
				// 	type: 'blob'
				// }))
				// reader.onload = (e) => {
				// 	let data = e.target.result
				// 	renderAsync(data, document.getElementById("preload_box"), null, {
				// 		className: "docx", // 默认和文档样式类的类名/前缀
				// 		inWrapper: false, // 启用围绕文档内容渲染包装器
				// 		ignoreWidth: false, // 禁止页面渲染宽度
				// 		ignoreHeight: false, // 禁止页面渲染高度
				// 		ignoreFonts: false, // 禁止字体渲染
				// 		breakPages: true, // 在分页符上启用分页
				// 		ignoreLastRenderedPageBreak: true, //禁用lastRenderedPageBreak元素的分页
				// 		experimental: false, //启用实验性功能（制表符停止计算）
				// 		trimXmlDeclaration: true, //如果为真，xml声明将在解析之前从xml文档中删除
				// 		debug: false, // 启用额外的日志记录
				// 	})


				// }
			},
			previewIMG(res, file) {
				let imgPreviewList = []
				if (Array.isArray(file)) {
					imgPreviewList = file.map((item) => {
						return item.url
					})
				} else {
					imgPreviewList.push(file.url)
				}
				if (imgPreviewList.length > 1) {
					this.previewoptions.navbar = true
				} else {
					this.previewoptions.navbar = false
				}
				if (this.previewImgModal) {
					this.images = imgPreviewList
					this.previewImgShow = true
				} else {
					viewerApi({
						options: this.previewoptions,
						images: imgPreviewList
					})
				}
			},
			previewPDF(res, file) {
				//this.pdfurl = file.path
				window.open(file.path, '_blank');
			},
			previewTXT(res, file) {
				let blob = this.blob
				let reader = new FileReader()
				reader.readAsText(new window.File([blob], file.name, {
					type: 'blob'
				}))
				reader.onload = function(e) {
					let data = e.target.result
					//console.log(data)
					let div = document.createElement('div')
					div.style.width = '100%'
					div.style.minHeight = '100%'
					div.style.padding = '20px'
					div.style.boxSizing = 'border-box'
					div.innerText = data
					document.getElementById("preload_box").appendChild(div)
				}
			},
			previewdownload() {
				this.download(this.file)
			},
			previewHide() {
				this.pdfurl = false
				this.blob = false
			},
			getFileType(file) {
				let filetype = file.name.split('.')
				filetype = filetype[filetype.length - 1]
				return filetype.toUpperCase()
			},
			blobToFile(theBlob, fileName) {
				theBlob.lastModifiedDate = new Date()
				theBlob.name = fileName
				return theBlob
			},


			downloadFilesAsZip(blobArray) {
				console.log(blobArray)
				const zip = new JSZip();
				const folder = zip.folder("files"); // 创建压缩包中的文件夹
				
				// 将 Blob 添加到 ZIP 中
				blobArray.forEach((blob) => {
					let fileName = blob.filename; // 如果没有文件名，则用默认名
					folder.file(fileName, blob.blob); // 添加 Blob 到 ZIP 文件中
				});

				// 生成 ZIP 并触发下载
				zip.generateAsync({
					type: "blob"
				}).then(content => {
					const a = document.createElement("a");
					const url = URL.createObjectURL(content);
					a.href = url;
					a.download = "files.zip";
					a.click();
					URL.revokeObjectURL(url); // 释放 URL
				});
			},
		},
		components: {
			pdf,
			customUpload,
			Viewer
		}
	}
</script>